function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.99995 1.20001C9.99406 1.20001 10.8 2.0059 10.8 3.00001V9.00001C10.8 9.99413 9.99406 10.8 8.99995 10.8H2.99995C2.00584 10.8 1.19995 9.99413 1.19995 9.00001V3.00001C1.19995 2.0059 2.00584 1.20001 2.99995 1.20001H8.99995ZM2.39995 9.00001C2.39995 9.33138 2.66858 9.60001 2.99995 9.60001H8.99995C9.33132 9.60001 9.59995 9.33138 9.59995 9.00001V6.60001H8.32434C8.06778 7.59681 7.18694 8.34299 6.12345 8.39689L5.99995 8.40001C4.92307 8.40001 4.01184 7.69076 3.70791 6.71389L3.67556 6.60001H2.39995V9.00001ZM8.99995 2.40001H2.99995C2.66858 2.40001 2.39995 2.66864 2.39995 3.00001V5.40001H4.19995C4.50765 5.40001 4.76126 5.63164 4.79591 5.93004L4.79995 6.00001C4.79995 6.66275 5.33721 7.20001 5.99995 7.20001C6.63257 7.20001 7.15085 6.71049 7.19666 6.08957L7.20399 5.93004C7.23598 5.65459 7.45453 5.43604 7.72998 5.40405L7.79995 5.40001H9.59995V3.00001C9.59995 2.66864 9.33132 2.40001 8.99995 2.40001Z",
  fill: "#151B26"
});

function SvgInboxNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxNav);
export default __webpack_public_path__ + "static/media/inboxNav.f679ad8d.svg";
export { ForwardRef as ReactComponent };